import { useState, useRef, useEffect } from "react";
import { Search, Sliders } from "react-feather";
import { SortFilter, SortType, SortDirection } from "../common/SortFilter";
import { Input } from "../ui/input";
import { Button } from "../ui/button";

interface SearchHeaderProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  onSortChange?: (type: SortType, direction: SortDirection) => void;
}

export const SearchHeader = ({
  searchTerm,
  onSearchChange,
  onSortChange,
}: SearchHeaderProps) => {
  const [showFilter, setShowFilter] = useState(false);
  const filterRef = useRef<HTMLDivElement>(null);

  // Handle click outside to close filter
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        filterRef.current &&
        !filterRef.current.contains(event.target as Node)
      ) {
        setShowFilter(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleApplySort = (type: SortType, direction: SortDirection) => {
    onSortChange?.(type, direction);
    setShowFilter(false);
  };
  const handleResetSort = () => {
    onSortChange?.("RANK", "desc");
    setShowFilter(false);
  };

  return (
    <>
      {/* Header */}
      <div className="mb-6">
        <h1 className="text-2xl font-semibold tracking-tight">
          Search new brands
        </h1>
      </div>

      {/* Search Section */}
      <div className="flex gap-3 mb-6">
        <div className="flex-1 relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground h-4 w-4" />
          <Input
            type="text"
            placeholder="Search brands"
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            className="pl-10"
          />
        </div>

        {/* Sort Button and Dropdown */}
        <div className="relative" ref={filterRef}>
          <Button
            variant="outline"
            size="icon"
            aria-label="Sort results"
            onClick={() => setShowFilter(!showFilter)}
          >
            <Sliders className="h-4 w-4 text-muted-foreground" />
          </Button>

          {/* Sort Dropdown */}
          {showFilter && (
            <div className="absolute right-0 mt-2 z-10">
              <SortFilter onApply={handleApplySort} onReset={handleResetSort} />
            </div>
          )}
        </div>
      </div>
    </>
  );
};
